import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { ToastService } from './toast-service';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class ListViewExpandableService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService, private toastCtrl: ToastService) { }

  getId = (): string => 'expandable';

  getTitle = (): string => 'Expandable';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'expandable/0', 'title': 'List big image', 'theme': 'layout1' },
      { 'url': 'expandable/1', 'title': 'Full image with CTA', 'theme': 'layout2' },
      { 'url': 'expandable/2', 'title': 'Centered with header', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): Array<any> => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'List big image',
      "header": "Catalogue",
      "items": [
        {
          "id": 1,
          "title": "Black dualshock controller",
          "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          "image": "assets/imgs/avatar/0.jpg",
          "expandItems": [
            {
              "id": 1,
              "title": "Objective",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/7.jpg",
              "details": "$399.99"
            },
            {
              "id": 2,
              "title": "Watch",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/6.jpg",
              "details": "$2058.99"
            },
            {
              "id": 3,
              "title": "Canon Photoaparat",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/5.jpg",
              "details": "$89.99"
            },
            {
              "id": 4,
              "title": "Watch Black",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/4.jpg",
              "details": "$1999.99"
            }
          ]
        },
        {
          "id": 2,
          "title": "Keyboard",
          "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          "image": "assets/imgs/avatar/2.jpg",
          "expandItems": [
            {
              "id": 1,
              "title": "Headphones",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/3.jpg",
              "details": "$99.99"
            },
            {
              "id": 2,
              "title": "Objective",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/7.jpg",
              "details": "$499.99"
            },
            {
              "id": 3,
              "title": "iPhone 8 Plus",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/1.jpg",
              "details": "$1199.99"
            },
            {
              "id": 4,
              "title": "Black dualshock controller",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/0.jpg",
              "details": "$798.99"
            }
          ]
        },
        {
          "id": 3,
          "title": "Watch Black",
          "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          "image": "assets/imgs/avatar/4.jpg",
          "expandItems": [
            {
              "id": 1,
              "title": "Keyboard",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/2.jpg",
              "details": "$589.99"
            },
            {
              "id": 2,
              "title": "Watch Black",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/4.jpg",
              "details": "$799.99"
            },
            {
              "id": 3,
              "title": "Watch",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/6.jpg",
              "details": "$99.99"
            },
            {
              "id": 4,
              "title": "Objective",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/7.jpg",
              "details": "$599.99"
            }
          ]
        },
        {
          "id": 4,
          "title": "iPhone 8 Plus",
          "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          "image": "assets/imgs/avatar/1.jpg",
          "expandItems": [
            {
              "id": 1,
              "title": "Watch",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/4.jpg",
              "details": "$412.99"
            },
            {
              "id": 2,
              "title": "Headphones",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/3.jpg",
              "details": "$657.99"
            },
            {
              "id": 3,
              "title": "Nikon Photoaparat",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/5.jpg",
              "details": "$58.99"
            },
            {
              "id": 4,
              "title": "Objective",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/7.jpg",
              "details": "$856.99"
            }
          ]
        },
        {
          "id": 5,
          "title": "Nikon Photoaparat",
          "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          "image": "assets/imgs/avatar/5.jpg",
          "expandItems": [
            {
              "id": 1,
              "title": "Watch",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/6.jpg",
              "details": "$999.99"
            },
            {
              "id": 2,
              "title": "Headphones",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/3.jpg",
              "details": "$299.99"
            },
            {
              "id": 3,
              "title": "Objective",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/7.jpg",
              "details": "$658.99"
            },
            {
              "id": 4,
              "title": "Keyboard",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/2.jpg",
              "details": "$158.99"
            }
          ]
        },
        {
          "id": 6,
          "title": "Watch",
          "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          "image": "assets/imgs/avatar/6.jpg",
          "expandItems": [
            {
              "id": 1,
              "title": "iPhone 8 Plus",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/1.jpg",
              "details": "$1008.99"
            },
            {
              "id": 2,
              "title": "Nikon Photoaparat",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/5.jpg",
              "details": "$258.99"
            },
            {
              "id": 3,
              "title": "Keyboard",
              "description": "Lorem ipsum.",
              "image": "assets/imgs/avatar/2.jpg",
              "details": "$628.99"
            },
            {
              "id": 4,
              "title": "Objective",
              "description": "Lorem ipsum",
              "image": "assets/imgs/avatar/7.jpg",
              "details": "$580.99"
            }
          ]
        }
      ]
    };
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'Full Image With Cta',
      "items": [
        {
          "id": 1,
          "backgroundImage": "assets/imgs/background/18.jpg",
          "title": "TIME TO TRAVEL ",
          "items": {
            "iconsStars": [
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": false,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              }
            ],
            "reviews": "4.12 (78 reviews)",
            "title": "Lorem ipsum dolor sit amet",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
          }
        },
        {
          "id": 2,
          "backgroundImage": "assets/imgs/background/17.jpg",
          "title": "TIME TO TRAVEL ",
          "items": {
            "iconsStars": [
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": false,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              }
            ],
            "reviews": "4.12 (78 reviews)",
            "title": "Lorem ipsum dolor sit amet",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
          }
        },
        {
          "id": 3,
          "backgroundImage": "assets/imgs/background/19.jpg",
          "title": "TIME TO TRAVEL ",
          "items": {
            "iconsStars": [
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": false,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              }
            ],
            "reviews": "4.12 (78 reviews)",
            "title": "Collegiate Skate Tour",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
          }
        },
        {
          "id": 4,
          "backgroundImage": "assets/imgs/background/15.jpg",
          "title": "TIME TO TRAVEL ",
          "items": {
            "iconsStars": [
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": true,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              },
              {
                "isActive": false,
                "iconActive": "icon-star",
                "iconInactive": "icon-star-outline"
              }
            ],
            "reviews": "4.12 (78 reviews)",
            "title": "Lorem ipsum dolor sit amet",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
          }
        }
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Centered With Header',
      "header": "Popular jackets",
      "items": [
        {
          "id": 1,
          "title": "Leather Moto Jacket",
          "subtitle": "Jacket",
          "button": "Buy",
          "price": "$516.55",
          "backgroundImage": "assets/imgs/background/1.jpg",
          "expandItems": [
            {
              "id": 1,
              "isChecked": "true",
              "title": "duffle longline puffer coat in mustard",
              "image": "assets/imgs/avatar/10.jpg",
              "details": "$99.99"
            },
            {
              "isChecked": "true",
              "title": "plush faux fur maxi coat with seam detailing",
              "image": "assets/imgs/avatar/11.jpg",
              "details": "$99.99"
            },
            {
              "id": 3,
              "isChecked": "false",
              "title": "Weekday candace reversible jacket in black",
              "image": "assets/imgs/avatar/12.jpg",
              "details": "$99.99",
            },
            {
              "id": 4,
              "isChecked": "false",
              "title": "New Look boxy puffer jacket in black",
              "image": "assets/imgs/avatar/13.jpg",
              "details": "$99.99"
            },
            {
              "id": 5,

              "isChecked": "false",
              "title": "The North Face Himalayan puffer jacket in black",
              "image": "assets/imgs/avatar/14.jpg",
              "details": "$99.99"
            }
          ]
        },
        {
          "id": 2,
          "title": "Leather Moto Jacket",
          "subtitle": "Jacket",
          "button": "Buy",
          "price": "$516.55",
          "backgroundImage": "assets/imgs/background/9.jpg",
          "expandItems": [
            {
              "id": 1,
              "isChecked": "false",
              "title": "maxi raincoat with animal borg lining",
              "image": "assets/imgs/avatar/15.jpg",
              "details": "$99.99"
            },
            {
              "isChecked": "true",
              "title": "faux fur lined raincoat in mink",
              "image": "assets/imgs/avatar/16.jpg",
              "details": "$99.99"
            },
            {
              "id": 3,
              "isChecked": "false",
              "title": "contrast stitch raincoat in black",
              "image": "assets/imgs/avatar/17.jpg",
              "details": "$99.99",
            },
            {
              "id": 4,
              "isChecked": "false",
              "title": "London oversized padded parka with hood",
              "image": "assets/imgs/avatar/18.jpg",
              "details": "$99.99"
            },
            {
              "id": 5,

              "isChecked": "false",
              "title": "hopma longline puffer",
              "image": "assets/imgs/avatar/19.jpg",
              "details": "$99.99"
            }
          ]
        },
        {
          "id": 3,
          "title": "Leather Moto Jacket",
          "subtitle": "Jacket",
          "button": "Buy",
          "price": "$516.55",
          "backgroundImage": "assets/imgs/background/18.jpg",
          "expandItems": [
            {
              "id": 1,
              "isChecked": "true",
              "title": "faux fur lined raincoat in mink",
              "image": "assets/imgs/avatar/20.jpg",
              "details": "$99.99"
            },
            {
              "isChecked": "true",
              "title": "maxi raincoat with animal borg lining",
              "image": "assets/imgs/avatar/21.jpg",
              "details": "$99.99"
            },
            {
              "id": 3,
              "isChecked": "false",
              "title": "luxe parka with faux fur trim in khak",
              "image": "assets/imgs/avatar/22.jpg",
              "details": "$99.99",
            },
            {
              "id": 4,
              "isChecked": "false",
              "title": "parka with detachable faux fur liner in oxblood",
              "image": "assets/imgs/avatar/23.jpg",
              "details": "$99.99"
            },
            {
              "id": 5,

              "isChecked": "false",
              "title": "luxe parka with faux fur trim in khaki",
              "image": "assets/imgs/avatar/9.jpg",
              "details": "$99.99"
            }
          ]
        },
        {
          "id": 4,
          "title": "Leather Moto Jacket",
          "subtitle": "Jacket",
          "button": "Buy",
          "price": "$516.55",
          "backgroundImage": "assets/imgs/background/5.jpg",
          "expandItems": [
            {
              "id": 1,
              "isChecked": "true",
              "title": "parka with detachable faux fur liner in oxblood",
              "image": "assets/imgs/avatar/14.jpg",
              "details": "$99.99"
            },
            {
              "isChecked": "true",
              "title": "fitted puffer jacket in yellow",
              "image": "assets/imgs/avatar/20.jpg",
              "details": "$99.99"
            },
            {
              "id": 3,
              "isChecked": "false",
              "title": "leather single breasted trench coat in black",
              "image": "assets/imgs/avatar/13.jpg",
              "details": "$99.99",
            },
            {
              "id": 4,
              "isChecked": "false",
              "title": "leather racer jacket in black with quilted lining",
              "image": "assets/imgs/avatar/15.jpg",
              "details": "$99.99"
            },
            {
              "id": 5,

              "isChecked": "false",
              "title": "leather jacket in black with jersey hood",
              "image": "assets/imgs/avatar/17.jpg",
              "details": "$99.99"
            }
          ]
        },
      ]
    };
  }

  load(item: any): Observable<any> {
    this.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('listView/expandable/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            this.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            this.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        this.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
